import {ChangeEvent, useEffect, useState} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {toast} from 'react-toastify'
import Swal from 'sweetalert2'
import {Campaign} from '../../models/Campaign'
import MarketingService from '../../../api/MarketingService'
import ReactPaginate from 'react-paginate'
import {Link} from 'react-router-dom'
import authAPI from '../../../api/authAPI'
import { id } from 'date-fns/locale'

function CampaignList() {
  const [currentUser, setCurrentUser] = useState({user_id: null})

  const [searchQuery, setSearchQuery] = useState('')

  const [campaignList, setCampaignList] = useState<Campaign[]>([] as Campaign[])

  const [offset, setOffset] = useState<number>(0)
  const [limit, setLimit] = useState<number>(10)
  const [totalPages, setTotalPages] = useState<number>(0)

  useEffect(() => {
    getCurrentUser()
  }, [])

  useEffect(() => {
    getCampaignList()
  }, [currentUser])

  // get current user
  const getCurrentUser = () => {
    authAPI.getMyProfile().then((res: any) => {
      if (res?.data?.success) {
        setCurrentUser(res?.data.data)
      } else {
        setCurrentUser({user_id: null})
      }
    })
  }

  const getCampaignList = () => {
    MarketingService.getCampaignList().then(
      (res: any) => {
        if (res?.data?.success) {
          const campaignList = res?.data?.data.filter((x: any) => x.user_id === currentUser.user_id)
          setCampaignList(campaignList)
          setTotalPages(Math.ceil(res?.data?.count / limit))
        } else {
          toast.error(res?.data?.message, {theme: 'dark'})
          setCampaignList([])
          setTotalPages(0)
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
  }

  const handlePageChange = (selected: any) => {
    const newOffset = selected === 0 ? 0 : selected * limit
    setOffset(newOffset)

    // const newOffset = selected === 0 ? 0 : selected * limit
    // let data = {
    //   limit: limit,
    //   offset: newOffset,
    // }
    // PackageService.getPackageList(data).then(
    //   (res: any) => {
    //     if (res?.data?.success) {
    //       setPackageList(res?.data?.data)
    //       setTotalPages(Math.ceil(res?.data?.count / limit))
    //       setOffset(newOffset)
    //     } else {
    //       toast.error(res?.data?.message, {theme: 'dark'})
    //       setPackageList([])
    //     }
    //   },
    //   (err: any) => {
    //     toast.error(err?.response?.data?.message, {theme: 'dark'})
    //   }
    // )
  }

  const handleDelete = (id: number) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to delete?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result: any) => {
      if (result.isConfirmed) {
        MarketingService.deleteCampaign(id).then(
          (res: any) => {
            if (res?.data?.success) {
              toast.success(res?.data?.message, {theme: 'dark'})
              getCampaignList()
            } else {
              toast.error(res?.data?.message, {theme: 'dark'})
            }
          },
          (err: any) => {
            toast.error(err?.response?.data?.message, {theme: 'dark'})
          }
        )
      }
    })
  }


  const handleStatusToggle = (id: number) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to change the status?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, change it!',
    }).then((result: any) => {
      if (result.isConfirmed) {
        MarketingService.changeCampaignStatus(id).then(
          (res: any) => {
            if (res?.data?.success) {
              toast.success(res?.data?.message, {theme: 'dark'})
              getCampaignList()
            } else {
              toast.error(res?.data?.message, {theme: 'dark'})
            }
          },
          (err: any) => {
            toast.error(err?.response?.data?.message, {theme: 'dark'})
          }
        )
      }
    })
  }

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value)
  }

  const filteredCampaigns = campaignList.filter((campaign) =>
    campaign.title.toLowerCase().includes(searchQuery.toLowerCase())
  )

  useEffect(() => {
    setTotalPages(Math.ceil(filteredCampaigns.length / limit))
    setOffset(0)
  }, [filteredCampaigns.length])

  return (
    <>
      <div style={{flexDirection: 'row', display: 'flex', justifyContent: 'space-between'}}>
        <p style={{fontSize: 30, color: '#686868'}}>Campaign List 🎉</p>
        <Link
          to='/add-campaign'
          type='button'
          style={{
            backgroundColor: '#EBF3F8',
            borderRadius: 113,
            width: 226,
            height: 56,
            fontSize: 16,
            color: '#161616',
            fontWeight: 'bold',
            textAlign: 'center',
            alignContent: 'center',
          }}
        >
          + New Campaign
        </Link>
      </div>
      {/* Table */}
      <div className='col-lg-12' style={{marginTop: 25}} />
      <div className='mb-5'>
        <div className='table-responsive'>
          <div className='d-flex justify-content-between w-25 pb-2'>
            <input
              type='text'
              className='form-control mb-3'
              placeholder='Search campaigns...'
              value={searchQuery}
              onChange={handleSearchChange}
            />
          </div>
          <div className='d-flex justify-content-between w-100 p-3 pb-2'>
            <td className='d-flex w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Title</span>
            </td>
            <td className='d-flex w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Route</span>
            </td>
            <td className='d-flex w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Reception Type</span>
            </td>
            <td className='w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Status</span>
            </td>
            <td className='text-end w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Action</span>
            </td>
          </div>
          {filteredCampaigns.slice(offset, offset + limit).map(
            (campaign, index) =>
              (campaign.status === 1 || campaign.status === 2) && (
                <div
                  className='p-3 py-2 mb-2 bg-white d-flex justify-content-between w-100'
                  key={index}
                  style={{marginBottom: 20, borderRadius: 5}}
                >
                  <td className='d-flex w-lg-25'>
                    <span className='text-dark fw-bold d-block fs-5 d-flex align-items-center'>
                      {campaign.title}
                    </span>
                  </td>
                  <td className='d-flex w-lg-25'>
                    <span className='text-dark fw-bold d-block fs-5 d-flex align-items-center'>
                      {campaign.route == 1 ? 'Email' : 'SMS'}
                    </span>
                  </td>
                  <td className='d-flex w-lg-25'>
                    <span className='text-dark fw-bold d-block fs-5 d-flex align-items-center'>
                      {campaign.reception_type === 1
                        ? 'All Leads'
                        : campaign.reception_type === 2
                        ? 'Individual'
                        : 'Company'}
                    </span>
                  </td>
                  <td className='d-flex w-lg-25'>
                    <span
                      className={`fw-bold d-block fs-5 d-flex align-items-center ${
                        campaign.status === 1 ? 'text-success' : 'text-danger'
                      }`}
                    >
                      {campaign.status === 1 ? 'Active' : 'In-active'}
                    </span>
                  </td>
                  <td className='d-flex justify-content-end w-lg-25'>
                    <Link
                      to={'/campaign/details/' + campaign?.id}
                      className='text-dark fw-bold text-hover-primary fs-6 text-capitalize'
                    >
                      <button
                        type='button'
                        //   onClick={() => handleViewDetails(packagee.id)}
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm mx-1'
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        title='Details'
                      >
                        <KTSVG
                          path='/media/icons/duotune/general/detail.svg'
                          className='svg-icon-3'
                        />
                      </button>
                    </Link>
                    <Link
                      to={'/edit-campaign/' + campaign?.id}
                      
                      className='text-dark fw-bold text-hover-primary fs-6 text-capitalize'
                    >
                      <button
                        type='button'
                        //   onClick={() => handleViewDetails(packagee.id)}
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm mx-1'
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        title='Edit'
                      >
                      <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                      </button>
                    </Link>
                    <button
                      onClick={() => handleDelete(campaign?.id)}
                      type='button'
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm mx-1'
                      data-bs-toggle='tooltip'
                      data-bs-placement='top'
                      title='Delete'
                    >
                      <KTSVG
                        path='/media/icons/duotune/general/gen027.svg'
                        className='svg-icon-3'
                      />
                    </button>
                    <div className='d-flex justify-content-end flex-shrink-0 mx-1'>
                      {campaign.status === 1 && (
                        <div
                          className='d-flex align-items-center'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          title='Toggle Status'
                        >
                          <button
                            className='status-holder active-status'
                            onClick={() => handleStatusToggle(campaign.id)}
                          >
                            <div className='d-flex align-items-center justify-content-end'>
                              <div className='active-user active-status-light'></div>
                            </div>
                          </button>
                        </div>
                      )}
                      {campaign.status === 2 && (
                        <div
                          className='d-flex align-items-center'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          title='Toggle Status'
                        >
                          <button
                            className='status-holder pending-status'
                            onClick={() => handleStatusToggle(campaign.id)}
                          >
                            <div className='d-flex align-items-center'>
                              <div className='active-user pending-status-light'></div>
                            </div>
                          </button>
                        </div>
                      )}
                    </div>
                  </td>
                </div>
              )
          )}
        </div>
      </div>
      {/* Pagination */}
      {totalPages > 0 && (
        <ReactPaginate
          previousLabel='Previous'
          nextLabel='Next'
          breakLabel='...'
          pageCount={totalPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={(selected) => handlePageChange(selected.selected)}
          containerClassName='pagination'
          activeClassName='active'
        />
      )}
    </>
  )
}

export default CampaignList
